import React from 'react'
import PropTypes from 'prop-types'

import isArray from 'lodash/isArray'

import { Container } from './styles'

const FieldError = ({ meta, bottom: bottomSpace, ml }) => {
  if (meta.touched && meta.error) {
    return (
      <Container bottom={bottomSpace} ml={ml}>
        <span>{isArray(meta.error) ? meta.error[0] : meta.error}</span>
      </Container>
    )
  }

  return null
}

FieldError.defaultProps = {
  bottom: -16,
  ml: 0,
}

FieldError.propTypes = {
  bottom: PropTypes.number,
  meta: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    touched: PropTypes.bool.isRequired,
  }).isRequired,
  ml: PropTypes.number,
}

export default FieldError
